"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.remoteConfig = void 0;
var firebase = __importStar(require("firebase/app"));
var analytics_1 = require("firebase/analytics");
var performance_1 = require("firebase/performance");
var remote_config_1 = require("firebase/remote-config");
var app = firebase.initializeApp({
    apiKey: "AIzaSyBU9Qoya6WRzMYbtj-CYkA_eRevFrbqlfs",
    authDomain: "vrchat-profile.firebaseapp.com",
    databaseURL: "https://vrchat-profile.firebaseio.com",
    projectId: "vrchat-profile",
    storageBucket: "vrchat-profile.appspot.com",
    messagingSenderId: "269703467196",
    appId: "1:269703467196:web:69cf9f24dc3347cc0280b9",
    measurementId: "G-1HH54K5ZRC",
});
(0, analytics_1.getAnalytics)(app);
(0, performance_1.getPerformance)(app);
exports.remoteConfig = (0, remote_config_1.getRemoteConfig)(app);
exports.remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
